import { useState, useEffect } from 'react';
import Navbar from './Navbar';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToInspection = () => {
    const element = document.getElementById('free-inspection');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Content */}
      <div className="relative min-h-screen flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/67f51db4f96409f24ba2350526d09876.jpg"
            alt="Professional Roofing Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-white">
              <div className="mb-6">
                <img
                  src="https://static.readdy.ai/image/31c62e42039e6e289d97944d8b0d7aa6/77cdc51489c74956193760ddc20e31c5.jpeg"
                  alt="Sorto's Premier Roofing Logo"
                  className="w-32 h-32 object-contain mb-8"
                />
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Sorto's Premier<br />
                <span className="text-orange-500">Roofing And Const LLC</span>
              </h1>
              <p className="text-xl lg:text-2xl mb-4 text-gray-200 font-light">
                Guaranteed Quality & Fast Service
              </p>
              <p className="text-lg mb-8 text-gray-300">
                Professional roofing solutions for residential and commercial properties
              </p>
              
              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4">
                <button
                  onClick={scrollToInspection}
                  className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  Free Inspection
                </button>
                <button
                  onClick={scrollToServices}
                  className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  View Services
                </button>
              </div>

              {/* Quick Contact */}
              <div className="mt-12 flex items-center gap-4">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-phone-fill text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-300">Call Us Now</p>
                  <a href="tel:4172295037" className="text-2xl font-bold hover:text-orange-500 transition-colors cursor-pointer">
                    (417) 229-5037
                  </a>
                </div>
              </div>
            </div>

            {/* Right Content - Feature Cards */}
            <div className="hidden lg:grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Full Warranty</h3>
                <p className="text-gray-300 text-sm">Guaranteed quality workmanship on all projects</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 mt-8">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Fast Service</h3>
                <p className="text-gray-300 text-sm">Quick response and professional completion</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-search-eye-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Free Inspection</h3>
                <p className="text-gray-300 text-sm">No obligation roof assessment</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 mt-8">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Expert Team</h3>
                <p className="text-gray-300 text-sm">Experienced professionals you can trust</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
